import { useEffect, useRef } from "react";
import stringUtils from "../_services/string-utils";

const useAutoFocus = (inputName, value, autoFocus) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current && stringUtils.isBlank(value) && autoFocus) {
            inputRef.current.focus();
        }
    }, [autoFocus, value]);
    return inputRef;
};

export default useAutoFocus;
